<template>
  <v-dialog
    :max-width="maxWidth"
    persistent
    v-model="dialog"
    :z-index="1000002"
  >
    <v-card class="pa-6" rounded="xl">
      <div class="d-flex flex-column align-center">
        <div
          :class="`tw-h-12 tw-w-12 ${iconBgColor} d-flex justify-center align-center tw-rounded-full`"
        >
          <v-icon :color="baseColor">{{ icon }}</v-icon>
        </div>

        <div class="my-3 text-center">
          <p
            class="text-subtitle-1 tw-font-semibold mb-2"
            :class="titleColor || 'tw-text-slate-900'"
          >
            {{ title }}
          </p>
          <p class="text-subtitle-2 text-slate-600">
            {{ message }}
          </p>
        </div>
      </div>

      <div class="d-flex align-center justify-center mt-6">
        <v-btn
          class="mr-3 tw-text-sm"
          variant="outlined"
          :color="cancelColor"
          rounded="xl"
          @click="handleCancel"
          size="large"
        >
          {{ cancelButtonText }}
        </v-btn>
        <v-btn
          :color="baseColor"
          variant="flat"
          rounded="xl"
          @click="handleConfirm"
          :loading="loadingConfirm"
          size="large"
          class="tw-text-sm"
        >
          {{ confirmButtonText }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  message: {
    type: String,
    required: true,
  },
  cancelButtonText: {
    type: String,
    required: true,
  },
  confirmButtonText: {
    type: String,
    required: true,
  },
  baseColor: {
    type: String,
    required: true,
  },
  titleColor: {
    type: String,
  },
  iconBgColor: {
    type: String,
    required: true,
  },
  cancelColor: {
    type: String,
    default: 'primary',
  },
  loadingConfirm: {
    type: Boolean,
    default: false,
  },
  maxWidth: {
    type: String,
    default: '500',
  },
})

const emits = defineEmits(['update:modelValue', 'cancel', 'confirm'])

const dialog = ref(props.modelValue)

watch(dialog, (newValue) => {
  emits('update:modelValue', newValue)
})

watch(
  () => props.modelValue,
  (newValue) => {
    dialog.value = newValue
  },
)

const handleCancel = () => {
  emits('cancel')
}

const handleConfirm = () => {
  emits('confirm')
}
</script>
